import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { ApplicationService } from 'services/application/application.service';
import { ErrorService } from 'services/error/error.service';
import { ScreenSizeService } from 'services/screensize/screensize.service';
import { UserService } from 'services/user/user.service';
var CabinetUnassignedComponent = /** @class */ (function () {
    function CabinetUnassignedComponent(appService, errorService, router, screenSizeService, userService) {
        this.appService = appService;
        this.errorService = errorService;
        this.router = router;
        this.screenSizeService = screenSizeService;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = [
            'FormattedRequestIssueNumber',
            'BoardMember',
            'Priority',
            'Subject',
            'CategoryLabel',
            'DateCreated',
            'Actions',
        ];
    }
    CabinetUnassignedComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    CabinetUnassignedComponent.prototype.ngOnInit = function () {
        var self = this;
        self.UnassignedRequests = null;
        self.NoData = false;
        self.SearchConducted = false;
        self.SearchParams = {
            srchUnassignedOnly: true,
        };
        self.User = null;
        self.ViewReady = false;
        self.UnassignedRequestsData = new MatTableDataSource([]);
        self.SmallDisplay = self.screenSizeService.ScreenSize.IsSmallSize;
        self.IsLargeOrWider = self.screenSizeService.ScreenSize.IsLg || self.screenSizeService.ScreenSize.IsXl;
        self.screenSizeService.ScreenSizeSub.pipe(takeUntil(self._subrelease)).subscribe(function (size) {
            self.SmallDisplay = size.IsSmallSize;
            self.IsLargeOrWider = self.screenSizeService.ScreenSize.IsLg || self.screenSizeService.ScreenSize.IsXl;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load data for use in the compoment.
            self.appService.PerformSearch(self.User.AuthToken, self.User.CurrentRole, self.SearchParams).subscribe(function (results) {
                self.UnassignedRequests = results || [];
                self.NoData = !self.UnassignedRequests.length;
                self.UnassignedRequestsData.data = self.NoData ? [{}] : self.UnassignedRequests;
                self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
                self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
                self.SearchConducted = true;
                self.ViewReady = true;
            }, function (error) { return self.errorService.HandleServiceError(error); });
        });
    };
    // #region Handle Edit
    CabinetUnassignedComponent.prototype.HandleEdit = function (req) {
        var self = this;
        if (!req || req.RequestID == null) {
            return;
        }
        self.router.navigate(['/edit', req.RequestID, 'cabinetunassigned']);
    };
    // #endregion
    // #region Handle Search
    CabinetUnassignedComponent.prototype.HandleSearch = function () {
        var self = this;
        self.appService.PerformSearch(self.User.AuthToken, self.User.CurrentRole, self.SearchParams).subscribe(function (results) {
            self.UnassignedRequests = results || [];
            self.NoData = !self.UnassignedRequests.length;
            self.UnassignedRequestsData.data = self.NoData ? [{}] : self.UnassignedRequests;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
            self.SearchConducted = true;
        }, function (error) { return self.errorService.HandleServiceError(error); });
    };
    return CabinetUnassignedComponent;
}());
export { CabinetUnassignedComponent };
